import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class LicensePricingForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      licenseId: [ '' ],
      // photoPrintLimit: ['', Validators.required],
      // photoUploadLimit: ['', Validators.required],
      // blockPricePhotoUpload: ['', Validators.required],
      // blockPricePhotoPrint: ['', Validators.required],
      // pricePerPhotoUpload: ['', Validators.required],
      // pricePerPhotoPrint: ['', Validators.required],
      type: [ '', Validators.required ],
      limit: [ -1, Validators.required ],
      unitPrice: [ 0, Validators.required ],
      blockPrice: [ 0, Validators.required ],
      isFree: [ false ],
      // pricePerPhotoUploadMonthly: ['', Validators.required],
      // pricePerPhotoPrintMonthly: ['', Validators.required]
    });
  }
}
